{
  "name": "angular",
  "version": "2026.2.3",
  "license": "MIT",
  "scripts": {
    "start:base": "node --max_old_space_size=10240 ./node_modules/@angular/cli/bin/ng serve --poll=2000 --host 0.0.0.0 --live-reload=false",
    "start": "npm run start:base",
    "start:local": "npm run start:base -- --configuration=local",
    "start:core-dev": "npm run start:base -- --configuration=core-dev",
    "start:forms-dev": "npm run start:base -- --configuration=forms-dev",
    "start:tbm-dev": "npm run start:base -- --configuration=tbm-dev",
    "start:bim-dev": "npm run start:base -- --configuration=bim-dev",
    "start:pgd-dev": "npm run start:base -- --configuration=pgd-dev",
    "start:scm-dev": "npm run start:base -- --configuration=scm-dev",
    "start:mobile-dev": "npm run start:base -- --configuration=mobile-dev",
    "start:bit-dev": "npm run start:base -- --configuration=bit-dev",
    "start:dzy-dev": "npm run start:base -- --configuration=dzy-dev",
    "start:sensors-dev": "npm run start:base",
    "start:hsw-tst": "npm run start:base",
    "start:ims-tst": "npm run start:base -- --configuration=ims-tst",
    "start:iqm-ch-tst": "npm run start:base -- --configuration=iqm-ch-tst",
    "start:forms-tst": "npm run start:base -- --configuration=forms-tst",
    "start:strabag-tst": "npm run start:base -- --configuration=strabag-tst",
    "start:platform-tst": "npm run start:base -- --configuration=platform-tst",
    "start:mischek-tst": "npm run start:base -- --configuration=mischek-tst",
    "start:academy": "npm run start:base -- --configuration=academy",
    "start:ub2c": "npm run start:base -- --configuration=ub2c",
    "start:ub2c-tst": "npm run start:base -- --configuration=ub2c-tst",
    "start:e2e": "npm run start:base -- --configuration=e2e",
    "hmr": "node --max_old_space_size=10240 ./node_modules/@angular/cli/bin/ng serve --hmr --poll=2000 --host 0.0.0.0",
    "build": "cross-env NG_BUILD_OPTIMIZE_CHUNKS=1 node --max_old_space_size=10240 ./node_modules/@angular/cli/bin/ng build angular",
    "buildProd": "cross-env NG_BUILD_OPTIMIZE_CHUNKS=1 node --max_old_space_size=12288 ./node_modules/@angular/cli/bin/ng build angular --configuration production",
    "testCI": "vitest run",
    "lint": "ng lint",
    "translate": "node translate-new.js",
    "translate:force": "node translate-new.js -f",
    "sortTranslationLabels": "node translations-labels-sorting.js",
    "prepare": "husky",
    "translationDev": "concurrently -n TRANS,APP -c green,cyan \"npm run translations:mock\"",
    "translations:mock": "node -r dotenv/config tools/translations-mock/server.mjs dotenv_config_path=.env.local"
  },
  "private": true,
  "overrides": {
    "picomatch": "4.0.4",
    "micromatch": {
      "picomatch": "2.3.2"
    }
  },
  "lint-staged": {
    "src/**/*.ts": [
      "node --max_old_space_size=10240 ./node_modules/eslint/bin/eslint --fix"
    ],
    "projects/**/*.ts": [
      "node --max_old_space_size=10240 ./node_modules/eslint/bin/eslint --fix"
    ]
  },
  "dependencies": {
    "@angular/animations": "^21.2.6",
    "@angular/cdk": "^21.2.4",
    "@angular/common": "^21.2.6",
    "@angular/compiler": "^21.2.6",
    "@angular/core": "^21.2.6",
    "@angular/forms": "^21.2.6",
    "@angular/google-maps": "^21.2.4",
    "@angular/localize": "^21.2.6",
    "@angular/material": "^21.2.4",
    "@angular/platform-browser": "^21.2.6",
    "@angular/platform-browser-dynamic": "^21.2.6",
    "@angular/router": "^21.2.6",
    "@azure/msal-angular": "^4.0.21",
    "@azure/msal-browser": "^4.26.2",
    "@bluehalo/ngx-leaflet": "^21.0.0",
    "@elastic/apm-rum-angular": "^3.0.7",
    "@google-cloud/translate": "^9.3.0",
    "@iris/adsk-forge": "^21.0.0",
    "@iris/api-query": "^21.0.0",
    "@iris/bim-viewer": "^21.0.0",
    "@iris/bootstrap": "^21.0.0",
    "@iris/dhtmlx-scheduler-ultimate": "^5.3.7",
    "@karelics/angular-unleash-proxy-client": "^19.0.0",
    "@lezer/highlight": "^1.2.3",
    "@mat-datetimepicker/core": "^17.0.4",
    "@microsoft/fetch-event-source": "^2.0.1",
    "@microsoft/signalr": "^10.0.0",
    "@ngrx/component": "^21.1.0",
    "@ngrx/component-store": "^21.1.0",
    "@ngrx/effects": "^21.1.0",
    "@ngrx/entity": "^21.1.0",
    "@ngrx/operators": "^21.1.0",
    "@ngrx/router-store": "^21.1.0",
    "@ngrx/signals": "^21.1.0",
    "@ngrx/store": "^21.1.0",
    "@ngrx/store-devtools": "^21.1.0",
    "@ngx-strakit/cdk": "^21.8.23",
    "@ngx-strakit/fontawesome-pro": "^5.14.0",
    "@ngx-strakit/validation": "^21.8.23",
    "@ngx-translate/core": "^17.0.0",
    "@sentry/angular": "^10.46.0",
    "@sindresorhus/slugify": "^3.0.0",
    "@stomp/rx-stomp": "^2.3.0",
    "@stomp/stompjs": "^7.3.0",
    "@tinymce/tinymce-angular": "^9.1.1",
    "@types/d3": "^7.4.3",
    "@types/sockjs-client": "^1.5.4",
    "ag-grid-angular": "^32.3.3",
    "ag-grid-community": "^32.3.3",
    "angular-gridster2": "^21.0.1",
    "angular-in-memory-web-api": "^0.21.0",
    "angular2-hotkeys": "^16.0.1",
    "animate.css": "4.1.1",
    "buffer": "^6.0.3",
    "codemirror": "^6.0.2",
    "compressorjs": "^1.2.1",
    "cronstrue": "^3.14.0",
    "cytoscape": "^3.33.1",
    "cytoscape-cola": "^2.5.1",
    "d3": "^7.9.0",
    "dexie": "^4.3.0",
    "dompurify": "^3.3.3",
    "exif-js": "github:exif-js/exif-js",
    "file-saver": "2.0.5",
    "highcharts": "^12.2.0",
    "highcharts-angular": "^5.0.0",
    "jszip": "^3.10.1",
    "konva": "^9.3.2",
    "leaflet": "^1.9.4",
    "leaflet-lasso": "2.2.12",
    "leaflet.markercluster": "^1.5.3",
    "lodash": "^4.17.23",
    "luxon": "^3.7.2",
    "ng2-file-upload": "^10.0.0",
    "ngx-clipboard": "16.0.0",
    "ngx-cookie-service": "^21.3.1",
    "ngx-extended-pdf-viewer": "^25.6.1",
    "ngx-img-cropper": "^14.0.1",
    "ngx-infinite-scroll": "^21.0.0",
    "ngx-tippy-wrapper": "^6.3.0",
    "pako": "^2.1.0",
    "qrcode": "^1.5.4",
    "rxjs": "^7.8.2",
    "sass": "^1.96.0",
    "signature_pad": "^5.1.3",
    "simple-git": "^3.33.0",
    "sockjs-client": "^1.6.1",
    "supercluster": "^8.0.1",
    "tinymce": "^5.10.9",
    "tippy.js": "^6.3.7",
    "tslib": "^2.8.1",
    "unleash-proxy-client": "^3.7.8",
    "uuid": "^11.0.0",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.3.1",
    "@analogjs/vitest-angular": "^2.3.1",
    "@angular/build": "^21.2.4",
    "@angular/cli": "^21.2.4",
    "@angular/compiler-cli": "^21.2.6",
    "@angular/elements": "^21.2.6",
    "@angular/language-service": "^21.2.6",
    "@eslint/js": "^10.0.1",
    "@ngrx/schematics": "^21.1.0",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@testing-library/angular": "^19.2.1",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/user-event": "^14.6.1",
    "@types/d3": "^7.4.3",
    "@types/dhtmlxscheduler": "^4.3.44",
    "@types/dompurify": "^3.2.0",
    "@types/file-saver": "2.0.7",
    "@types/forge-viewer": "^7.99.1",
    "@types/leaflet": "~1.9.12",
    "@types/lodash": "^4.17.13",
    "@types/luxon": "^3.7.1",
    "@types/node": "^24.10.0",
    "@types/pako": "^2.0.4",
    "@types/sockjs-client": "^1.5.4",
    "@types/three": "^0.181.0",
    "@types/uuid": "^11.0.0",
    "@vitest/browser": "^4.1.1",
    "@vitest/coverage-v8": "^4.1.1",
    "@webcomponents/custom-elements": "^1.6.0",
    "angular-eslint": "^21.3.1",
    "concurrently": "^9.2.1",
    "cross-env": "^10.1.0",
    "dotenv": "^17.2.3",
    "eslint": "^10.1.0",
    "eslint-plugin-rxjs-x": "^1.0.1",
    "eslint-plugin-unused-imports": "^4.4.1",
    "express": "^5.2.1",
    "happy-dom": "^20.8.6",
    "husky": "^9.1.7",
    "jsdom": "^29.0.0",
    "lint-staged": "^16.4.0",
    "ng-packagr": "^21.2.1",
    "properties-parser": "^0.6.0",
    "resize-observer-polyfill": "1.5.1",
    "ts-node": "^10.9.2",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.57.2",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^4.1.1"
  }
}
